/**
 * WoxomQuote — Entry point
 *
 * This file imports all modules and exposes them to the global scope
 * for use by the existing vanilla JS app. New feature modules are
 * added here as ES module imports.
 *
 * data.js, iron-health-data.js, api.js, and cms-api.js remain as
 * separate script tags since they use window globals.
 */

// Feature modules (new functionality)
import { QuoteActions } from './modules/quote-actions.js';
import { QuotesDrawer } from './modules/quotes-drawer.js';
import { AgentIdentity } from './modules/agent-identity.js';
import { Onboarding } from './modules/onboarding.js';
import { CrossSell } from './modules/cross-sell.js';
import { RateChecker } from './modules/rate-checker.js';
import { HealthQuestionnaire } from './modules/health-questionnaire.js';
import { PlanScorer } from './modules/plan-scorer.js';

// Expose modules globally for use by existing code and HTML event handlers
window.WoxomQuote = {
  QuoteActions,
  QuotesDrawer,
  AgentIdentity,
  Onboarding,
  CrossSell,
  RateChecker,
  HealthQuestionnaire,
  PlanScorer,
};
